import { Icon } from '../../icon'
// import { useStyles } from './styles'
import { darkTheme } from '@/shared/styles/theme/dark'

export const DefaultTransactionHeader = () => {
  // const { classes } = useStyles()

  return (
    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
      <Icon
        view="transactionSuccessful"
        style={{ width: '44px', height: '44px' }}
      />
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '4px',
          color: darkTheme.colors.text.success,
          fontWeight: '450',
        }}
      >
        <span style={{ textAlign: 'center' }}>Successful</span>
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          <span style={{ fontFamily: 'Space Grotesk', fontSize: '32px', lineHeight: '32px', color: 'white' }}>
            {' '}
            +50{' '}
          </span>

          <img
            src="/assets/webp/currencies/TON.webp"
            style={{ width: '36px' }}
          />
        </div>
      </div>
    </div>
  )
}
